import { render, staticRenderFns } from "./KpiItem2020.vue?vue&type=template&id=2458814c&scoped=true&slot=header&"
import script from "./KpiItem2020.vue?vue&type=script&lang=js&"
export * from "./KpiItem2020.vue?vue&type=script&lang=js&"
import style0 from "./KpiItem2020.vue?vue&type=style&index=0&id=2458814c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458814c",
  null
  
)

export default component.exports